export { default } from "./routes/$.tsx";